/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const SITE_URL = "https://www.estrelaguia.com.br"
// Antes era /og-estrelaguia.png: un banner de Lua MAL RECORTADO que veían todos los que
// compartían un link del sitio (Facebook y WhatsApp). Imágenes propias por página en
// static/og/ (generadas por estrelaguia_og.py en el repo de las fanpages).
const DEFAULT_IMAGE = `${SITE_URL}/og/default.png`

function SEO({ description, lang, meta, title, pathname, image, type }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const canonical = pathname ? `${SITE_URL}${pathname}` : null
  // image puede venir absoluta (heroImage de Unsplash) o relativa (require de una carta);
  // og:image necesita URL absoluta.
  // Las PNG chicas llegan inlineadas como data:... por url-loader: no sirven de og:image.
  const ogImage = image && !image.startsWith("data:")
    ? image.startsWith("http")
      ? image
      : `${SITE_URL}${image}`
    : DEFAULT_IMAGE
  const ogType = type || "website"

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={title}
      link={canonical ? [{ rel: "canonical", href: canonical }] : []}
      meta={[
        { name: `description`, content: metaDescription },
        { property: `og:title`, content: title },
        { property: `og:description`, content: metaDescription },
        { property: `og:type`, content: ogType },
        { property: `og:image`, content: ogImage },
        { property: `og:site_name`, content: `EstrelaGuia` },
        { property: `og:locale`, content: `pt_BR` },
        ...(canonical ? [{ property: `og:url`, content: canonical }] : []),
        { name: `twitter:card`, content: `summary_large_image` },
        { name: `twitter:title`, content: title },
        { name: `twitter:description`, content: metaDescription },
        { name: `twitter:image`, content: ogImage },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `pt-BR`,
  meta: [],
  description: ``,
  pathname: ``,
  image: ``,
  type: `website`,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  pathname: PropTypes.string,
  image: PropTypes.string,
  type: PropTypes.string,
}

export default SEO
